<template>
  <div :class="['tabs', `tabs--${layout}`]">
    <ul class="tabs__nav">
      <template v-for="({ title, number, isHidden }, index) in navigation">
        <li
          v-if="!isHidden"
          :key="title"
          :class="['tabs__navItem', { 'tabs__navItem--active': activeTab === index }]"
          @click="changeTab(index)"
        >
          {{ title }}
          <span v-if="number" class="tabs__tabNumber">{{ number }}</span>
        </li>
      </template>
    </ul>
    <slot v-if="!isForbidden" :activeTab="activeTab" />
  </div>
</template>

<script>
export default {
  name: 'VTabs',
  props: {
    navigation: {
      type: Array,
      required: true,
    },
    editUrl: {
      type: Boolean,
      default: true,
    },
    layout: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      activeTab: 0,
      isForbidden: false,
    };
  },
  created() {
    const tabIndex = parseInt(this.$route.query.tabIndex);
    if (tabIndex && tabIndex > 0 && tabIndex < this.navigation.length) {
      this.activeTab = tabIndex;
      this.isForbidden = this.navigation[tabIndex].isHidden;
    } else {
      this.activeTab = 0;
      this.isForbidden = this.navigation[0].isHidden;
    }
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
      if (this.editUrl) {
        history.replaceState({}, '', `${this.$route.path}?tabIndex=${index}`);
      }
      this.isForbidden = this.navigation[index].isHidden;
    },
  },
};
</script>

<style lang="scss">
.tabs {
  $root: &;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  position: relative;

  &__nav {
    background-color: $cWhite;
    display: flex;

    @include rwd('small-tablet') {
      overflow-x: auto;
      max-width: 100%;
    }
  }

  &__navItem {
    padding: 1.2rem 3.6rem 1.4rem 3rem;
    background-color: #f0f1f5;
    font-size: 1.6rem;
    line-height: 2rem;
    color: $cAddDark02;
    cursor: pointer;
    border-left: 1px solid $cAddLight;

    @include rwd('small-tablet') {
      white-space: nowrap;
    }

    &:first-of-type {
      border-color: transparent;
    }

    &--active {
      font-weight: 600;
      color: $cMainDark;
      background-color: $cWhite;
      cursor: default;
      border-color: transparent;

      + #{$root}__navItem {
        border-color: transparent;
      }
    }
  }

  &__content {
    height: 500px;
    width: 100%;
    background-color: $cWhite;
  }

  &__tabNumber {
    font-size: 1rem;
    background-color: $cSec;
    border-radius: 50%;
    color: $cWhite;
    font-weight: 700;
    margin-left: 1rem;
    padding: 0.3rem;
  }

  &--default {
  }

  &--primary {
  }
}
</style>
